import React from 'react';
import { GeneralLoyaltyDataService } from './general-loyalty-data.service';
import { StringUtilService } from '../../../shared/src/services/util/string-util.service';
import { LoyaltyPlansEnum } from '../enums/loyalty-plans.enum';
import { SvgIconMask } from '../../../shared/src/components/SvgIconMask';

export const DefaultLoyaltyService = {
    getEditableLoyaltyData() {
        const {
            headerStripData,
            loyaltyTableData,
            accordionsData,
        } = window?.defaultLoyalty || {};
        const loyaltyLevels = GeneralLoyaltyDataService.getPlanDetails();

        return {
            headerStripData,
            loyaltyLevels,
            loyaltyTableData,
            accordionsData,
        };
    },

    getLoyaltyLevelsProgressData() {
        let maxPoints = 7,
            CustomSvgIcon = null;

        const plan = GeneralLoyaltyDataService.getLoyaltyPlan();

        if (plan === LoyaltyPlansEnum.EDITABLE_DEFAULT) {
            const planDetails = GeneralLoyaltyDataService.getPlanDetails();
            const planIconSrc = GeneralLoyaltyDataService.getDefaultIcon();
            maxPoints = planDetails.length;
            CustomSvgIcon = <SvgIconMask
                iconUrl={planIconSrc}
                width={20}
                height={20}
                bgColor={'var(--cs-body-text-color)'}
            />;
        }

        return {
            maxPoints,
            CustomSvgIcon,
        };
    },

    getLoyaltyFoldData(currentLevelNumber) {
        let currentLevelName = '',
            currentLevelSlug = '',
            currentLevelColor = '',
            currentLevelIconUrl = '',
            nextLevelName = '',
            totalLevelsNum = '';

        const plan = GeneralLoyaltyDataService.getLoyaltyPlan();
        const loyaltyLevels = GeneralLoyaltyDataService.getPlanDetails();
        const currentLevelIndex = currentLevelNumber - 1;
        const currentLevelData = loyaltyLevels?.[currentLevelIndex];

        currentLevelName = currentLevelData?.description;
        currentLevelColor = currentLevelData?.colors?.main;
        nextLevelName = loyaltyLevels?.[currentLevelIndex + 1]?.description;
        totalLevelsNum = loyaltyLevels.length;

        if (plan === LoyaltyPlansEnum.EDITABLE_DEFAULT) {
            currentLevelSlug = StringUtilService.stringToKebabCase(currentLevelName);
            currentLevelIconUrl = currentLevelData?.images?.level;
        } else {
            currentLevelSlug = currentLevelData?.slug;
            currentLevelIconUrl = currentLevelData?.images?.foldIcon;
        }

        return {
            currentLevelName,
            currentLevelSlug,
            currentLevelColor,
            currentLevelIconUrl,
            nextLevelName,
            totalLevelsNum,
        };
    },
};
